import axiosInstant from "../axiosInstant";

export async function askLeonAI({
  message,
  language = "auto",
}) {
  try {
    const res = await axiosInstant.post("ai/chat", {
      message,
      language,
    });

    return res.data;
  } catch (error) {
    console.error("Leon AI error:", error);

    return (
      error?.response?.data || {
        success: false,
        error_type: "NETWORK_ERROR",
        message:
          "Sorry, our AI assistant is currently unavailable at the moment. Please try again later or contact Leon Gallery at info@leon-gallery.com.",
      }
    );
  }
}